import styles from '@/styles/Shop.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import RimSearch from '@/components/search/RimSearch/RimSearch'
import { getPageTitle } from '@/utils/helpers'
import { useTranslation } from 'next-i18next'
import PageInfo from '@/components/common/PageInfo/PageInfo'
import Raw from '@/components/common/Raw/Raw'
import GalleryViewSearchResult from '@/components/search/GalleryView/GalleryView'
import { wrapper } from '@/store/store'
import { getCategoryHighlight, getRunningQueriesThunk, useGetCategoryHighlightQuery } from '@/api/categoryHighlights'
import { set } from 'lodash'
import ContentSV, { meta as metaSV } from '@/content/seo/sv/falgar.mdx'
import ContentEN, { meta as metaEN } from '@/content/seo/en/rims.mdx'
import { SeoContent } from '@/lib/seo/seoPage'
import { useSeoLocaleContent } from '@/lib/seo/seoRoute'
import { useSeoLocale } from '@/lib/seo/useSeoLocale'
import { useSeoLinks } from '@/lib/seo/seoLinks'

const byLocale = {
  sv: { meta: metaSV, Content: ContentSV },
  en: { meta: metaEN, Content: ContentEN },
}

type Props = {}

const Rims = (props: Props) => {
  const { t } = useTranslation('common')
  const { data } = useGetCategoryHighlightQuery(220)
  const [hasSearch, setHasSearch] = React.useState<boolean>(false)
  const locale = useSeoLocale()
  const { meta, Content } = useSeoLocaleContent(byLocale)

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('rims:title'), locale)}</title>
        <meta name="description" content={t('rims:description') || ''} />
        {useSeoLinks(meta)}
      </Head>
      <main>
        <PageInfo>
          <h1>{t('rims:header')}</h1>
          <Raw content={t('rims:pageDescription')} />
        </PageInfo>
        <RimSearch
          onHasSearch={setHasSearch}
          onVehicleChange={() => setHasSearch(true)}
        />

        {!hasSearch && (
          <>
            <h3 className={styles.randomArticles}>{t('rims:randomProducts')}</h3>
            <GalleryViewSearchResult
              items={data || []}
              listId={"highlight_rims"}
              listName={"Highlight Rims"}
            />
          </>
        )}

        <PageInfo>
          <SeoContent demoteHeadings>
            <Content />
          </SeoContent>
        </PageInfo>
      </main>
    </BaseLayout>
  )
}

export default Rims

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    store.dispatch(getCategoryHighlight.initiate(220))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    // Fetch translations for static rendering
    const translations = await serverSideTranslations(context.locale || 'en', [
      'common',
      'rims',
      'shop',
      'footer',
    ])

    return {
      props: {
        ...translations,
      },
    }
  }
)